import * as React from 'react';
import styles from './SwipeContainer.module.css';
// Pixel after Swiping in one direction activates swiping
const MinSwipeDistance = 14;
class SwipeContainer extends React.Component {
    constructor() {
        super(...arguments);
        this.selectedIndex = 0;
        this.maxIndex = 0;
        this.firstRendering = true;
        this.width = 0;
        this.swiped = false;
        this.startPos = { x: 0, y: 0 };
        this.delta = { x: 0, y: 0 };
        this.preventEndRegistered = false;
        this.setSwipePosTimer = null;
        this.updateSwipePosTimer = null;
        this.handleEvent = null;
        this.swipeContainer = null;
        this.handleResize = () => {
            this.updateSwipePos();
        };
        this.setContainerRef = (node) => {
            this.swipeContainer = node;
            // Timeout for the banner to be rendered
            setTimeout(() => this.updateSwipePos(), 100);
            // if (this.props.onRef) this.props.onRef(node);
        };
        // Methods for swiping
        this.getPosition = (event) => {
            if (event.touches && event.touches[0]) {
                return {
                    x: event.touches[0].pageX,
                    y: event.touches[0].pageY
                };
            }
            else {
                return {
                    x: event.pageX,
                    y: event.pageY
                };
            }
        };
        /**
         * Start Event for swiping to register additional listeners
         * @param  {[type]} event
         */
        this.start = (event) => {
            this.swiped = false;
            if (this.swipeContainer) {
                this.swipeContainer.addEventListener('mousemove', this.handleEvent, false);
                this.swipeContainer.addEventListener('mouseup', this.handleEvent, false);
                this.swipeContainer.addEventListener('touchmove', this.handleEvent, false);
                this.swipeContainer.addEventListener('touchend', this.handleEvent, false);
            }
            this.startPos = this.getPosition(event);
        };
        /**
         * Move Event for updating the transform of the swiped element
         * @param  {[type]} event
         */
        this.move = (event) => {
            const position = this.getPosition(event);
            this.delta = {
                x: position.x - this.startPos.x,
                y: position.y - this.startPos.y
            };
            if (this.delta.x > MinSwipeDistance || this.delta.x < -MinSwipeDistance) {
                this.swiped = true;
            }
            else if ((!this.swiped && this.delta.y > MinSwipeDistance) || this.delta.y < -MinSwipeDistance) {
                // Cancel swiping if the user is scrolling
                this.swipeToIndex(this.selectedIndex, false);
                return;
            }
            if (this.delta.x > this.width / 2) {
                this.swipeLeft();
            }
            else if (this.delta.x < -this.width / 2) {
                this.swipeRight();
            }
            else if (this.swiped &&
                (this.delta.x < 0 || this.selectedIndex > 0) &&
                (this.delta.x > 0 || this.selectedIndex < this.maxIndex)) {
                this.translate(this.swipeContainer, this.delta.x - this.selectedIndex * this.width, 0, 0);
            }
            if (this.swiped) {
                this.stopAndPreventEvent(event);
                if (!this.preventEndRegistered) {
                    this.preventEndRegistered = true;
                    if (this.swipeContainer) {
                        this.swipeContainer.addEventListener('touchend', this.stopAndPreventEvent, false);
                        this.swipeContainer.addEventListener('mouseup', this.stopAndPreventEvent, false);
                    }
                }
            }
        };
        /**
         * End Event for swiping to the destination
         * @param  {[type]} event [description]
         * @return {[type]}       [description]
         */
        // eslint-disable-next-line no-unused-vars
        this.end = (event) => {
            if (this.swiped) {
                if (this.delta.x > this.width / 4) {
                    this.swipeLeft();
                }
                else if (this.delta.x < -this.width / 4) {
                    this.swipeRight();
                }
                else {
                    this.translate(this.swipeContainer, -this.selectedIndex * this.width, 0, this.props.duration);
                }
            }
            else {
                this.translate(this.swipeContainer, -this.selectedIndex * this.width, 0, this.props.duration);
            }
            this.removeMoveListener();
            this.stopAndPreventEvent(event);
        };
        this.stopAndPreventEvent = (event) => {
            if (this.props.stopPropagation && this.swiped) {
                if (this.swipeContainer) {
                    this.swipeContainer.removeEventListener('touchend', this.stopAndPreventEvent, false);
                    this.swipeContainer.removeEventListener('mouseup', this.stopAndPreventEvent, false);
                }
                this.preventEndRegistered = true;
                if (event.cancelable)
                    event.preventDefault();
                event.stopPropagation();
            }
        };
        this.onClick = (event) => {
            this.stopAndPreventEvent(event);
        };
        this.setSwipePos = (props) => {
            if (
            // SwipeContainer Ref hasn't yet found
            !this.swipeContainer ||
                // clientWidth hasn't yet been set
                !this.swipeContainer.clientWidth) {
                this.setSwipePosTimer = setTimeout(this.setSwipePos, 1, props);
                return;
            }
            this.updateSwipePos();
        };
        /**
         * Calculates Width of DOM Node of SwipeContainer
         * and swipes to current Index
         * @param props
         */
        this.updateSwipePos = (props = this.props) => {
            if (!this.swipeContainer)
                return;
            this.width = Math.ceil((props.width || this.swipeContainer.clientWidth) / props.amountOfItemsPerColumn);
            // MaxIndex is calculated by how many times one child fit in the scrollwidth (total length of row
            this.maxIndex = Math.round((this.swipeContainer.scrollWidth - this.swipeContainer.clientWidth) / this.width);
            if (this.selectedIndex > this.maxIndex)
                this.selectedIndex = this.maxIndex;
            this.swipeToIndex(this.selectedIndex, false);
        };
        /**
         * Swipe left if possible
         */
        this.swipeLeft = () => {
            if (this.selectedIndex > 0) {
                this.selectedIndex--;
            }
            this.swipeToIndex(this.selectedIndex, true);
        };
        /**
         * Swipe right if possible
         */
        this.swipeRight = () => {
            if (this.selectedIndex < this.maxIndex) {
                this.selectedIndex++;
            }
            this.swipeToIndex(this.selectedIndex, true);
        };
        /**
         * Swipe to the given index
         * Start Animation
         * @param  {[type]} index
         */
        this.swipeToIndex = (index, disableAutoSwipe) => {
            let duration = this.props.duration;
            if (!this.firstRendering && this.props.onSwipe && this.props.selectedIndex !== index) {
                this.props.onSwipe(index, disableAutoSwipe);
            }
            if (this.firstRendering) {
                duration = 0;
                this.firstRendering = false;
            }
            this.translate(this.swipeContainer, -index * this.width, 0, duration);
            this.removeMoveListener();
        };
        /**
         * Removes the move listeners
         */
        this.removeMoveListener = () => {
            if (this.swipeContainer) {
                this.swipeContainer.removeEventListener('mousemove', this.handleEvent, false);
                this.swipeContainer.removeEventListener('mouseup', this.handleEvent, false);
                this.swipeContainer.removeEventListener('touchmove', this.handleEvent, false);
                this.swipeContainer.removeEventListener('touchend', this.handleEvent, false);
            }
        };
    }
    componentWillMount() {
        // Index of columns wich will be centered
        this.selectedIndex = this.props.selectedIndex || 0;
        // Last Column Index
        this.maxIndex = 0;
    }
    componentDidMount() {
        this.handleEvent = (event) => {
            switch (event.type) {
                case 'mousedown':
                case 'touchstart':
                    this.start(event);
                    break;
                case 'mousemove':
                case 'touchmove':
                    this.move(event);
                    break;
                case 'mouseup':
                case 'mouseleave':
                case 'touchend':
                    this.end(event);
                    break;
                default:
                    break;
            }
        };
        window.addEventListener('resize', this.handleResize);
        if (this.swipeContainer) {
            this.swipeContainer.addEventListener('touchstart', this.handleEvent, false);
            this.swipeContainer.addEventListener('mousedown', this.handleEvent, false);
        }
        // First Rendering is set to suppress Animation at the first rendering,
        // because of async SelectedIndex Changing
        this.firstRendering = true;
        this.setSwipePos(this.props);
    }
    componentWillReceiveProps(nextProps) {
        // Changes of selected Index
        const previousMaxIndex = this.maxIndex;
        let newSelectedIndex;
        if (React.Children.count(nextProps.children) !== React.Children.count(this.props.children)) {
            this.updateSwipePosTimer = window.setTimeout(() => {
                this.updateSwipePos(nextProps);
            }, 100); // Handle updates on changed children size (needs timeout)
        }
        else if (nextProps.width !== this.props.width && nextProps.width) {
            this.updateSwipePos(nextProps);
        }
        if (nextProps.selectedIndex !== undefined) {
            newSelectedIndex = nextProps.selectedIndex;
        }
        else {
            newSelectedIndex = this.selectedIndex;
        }
        // Amount of Columns changed
        if (nextProps.amountOfItemsPerColumn !== this.props.amountOfItemsPerColumn)
            this.updateSwipePos(nextProps);
        // Correct the swipeIndex if the maxIndex is smaller than the current index
        if (newSelectedIndex === previousMaxIndex && this.maxIndex < newSelectedIndex) {
            newSelectedIndex = this.maxIndex;
        }
        if (!this.firstRendering && newSelectedIndex !== this.props.selectedIndex) {
            this.swipeToIndex(newSelectedIndex, false);
        }
        this.selectedIndex = newSelectedIndex;
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
        if (this.swipeContainer) {
            this.swipeContainer.removeEventListener('touchstart', this.handleEvent, false);
            this.swipeContainer.removeEventListener('mousedown', this.handleEvent, false);
        }
        if (this.setSwipePosTimer) {
            clearTimeout(this.setSwipePosTimer);
            this.setSwipePosTimer = null;
        }
        if (this.updateSwipePosTimer) {
            clearTimeout(this.updateSwipePosTimer);
            this.updateSwipePosTimer = null;
        }
    }
    /**
     * Translates the element with the given distance
     * @param  {[type]} dist
     * @param  {[type]} speed
     */
    translate(element, distX, distY, speed) {
        const style = element && element.style;
        const distValX = this.parseTransformValue(distX);
        const distValY = this.parseTransformValue(distY);
        if (!style)
            return;
        style.webkitTransitionDuration = style.MozTransitionDuration = style.msTransitionDuration = style.OTransitionDuration = style.transitionDuration =
            speed + 'ms';
        style.webkitTransform = `translateX(${distValX}) translateY(${distValY}) translateZ(0)`;
        style.msTransform = style.MozTransform = style.OTransform = `translateX(${distValX}) translateY(${distValY})`;
    }
    parseTransformValue(value) {
        if (typeof value === 'number')
            return value + 'px';
        return value;
    }
    render() {
        return (React.createElement("div", { className: styles.slideContainer, onClick: this.onClick, ref: this.setContainerRef }, this.props.children));
    }
}
export default SwipeContainer;
//# sourceMappingURL=SwipeContainer.js.map